// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6fbecc6b","453":"284b116a","455":"681734aa","952":"66743572"}[chunkId] + ".chunk.js";
};